/* global google */
import Vue from 'vue'

export function getCurrentAddress(latLng) {
  return new Promise((resolve) => {
    const geocoder = new google.maps.Geocoder()
    geocoder.geocode({ location: latLng }, (results, status) => {
      if (status === 'OK') {
        if (results[0]) {
          resolve({
            showErrow: false,
            address: results[0].formatted_address,
          })
        }
      } else {
        resolve({ showError: true })
      }
    })
  })
}

export function setFormErrors(errors, commit) {
  if (errors) {
    Object.entries(errors).forEach((e) => {
      commit('setError', {
        field: e[0],
        error: e[1][0],
      })
    })
    return true
  }
  return false
}

export function getWhiteLabelValueByName(valueName, defaultValue) {
  if (Vue.prototype.$whitelabel) {
    return Vue.prototype.$whitelabel[valueName] ? Vue.prototype.$whitelabel[valueName] : defaultValue
  }
  return defaultValue
}
